import { types, actions } from './requests'
export const GETSIMPLEARTICLELIST_TYPES = {
    ...types('GETSIMPLEARTICLELIST'),
}
export const GETSIMPLEARTICLELIST_ACTIONS = {
    ...actions('GETSIMPLEARTICLELIST'),
}